import { lazy } from 'react';

export const LocaleSelector = lazy(() => import(/* webpackChunkName: "locale-selector" */ './selector'));
export const ProposeLocale = lazy(() => import(/* webpackChunkName: "locale-selector" */ './propose'));
